import moment from "moment";
import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {store} from '../../redux/store';
import Header from "../headerComponent/Header";
import LeftMenu from "../leftSideComponent/LeftSide";
import history from "../../auth/history";
import { setEndDate, setStartDate } from "../../redux/misc-data/misc-data.action";
class PaymentDetails extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			message: '',

		}
	}

	componentDidMount() {

	}
	componentWillUnmount() {
	}
	printdiv = (event) => {
		event.preventDefault();
		var divContents = document.getElementById("loaddtl").innerHTML;
		var a = window.open('', '', 'height=1000, width=1000');
		a.document.write('<html>');
		a.document.write('<body>');
		a.document.write(divContents);
		a.document.write('</body></html>');
		a.document.close();
		a.print();
	}
	goToBillList=(event)=>{
		event.preventDefault();
		store.dispatch(setStartDate(''));
		store.dispatch(setEndDate(''));
		setTimeout(() => {
			history.push('/bill-list');
		history.go();
		}, 200);
		
	}


	render() {

		return (
			<div>
				<div class="main">
					<LeftMenu />

					<div class="right-side">
						<div class="container-fluid">

							<Header />
							<div class="row">
								<div class="col-12 col-lg-8">
									<div class="card">
										<div class="dashhead">
											<h3>Bill Payment Details</h3>
											<div class="backbtn">
												{/* <Link to='/bill-list'> */}
													<button type="button" class="back" onClick={this.goToBillList}>Back</button>
												{/* </Link> */}
											</div>
										</div>

										<div class="loaddtl" id="loaddtl">
											<h4>Thank you, Bill Payment has been done successfully!</h4>
											<div class="table-responsive">
												<table class="table table-bordered">
													<thead>
														<tr>
															<td width="150">Bill Pay Amount:</td>
															<td>₹ {parseFloat(this.props.selectedAmount).toFixed(2)}</td>
														</tr>
														<tr>
															<td>Surcharge:</td>
															<td>₹ 0</td>
														</tr>
														<tr>
															<td>Bill Count</td>
															<td>{this.props.currentBatch.consumerList.length}</td>
														</tr>

														<tr>
															<td>Total Amount</td>
															<td>₹ {parseFloat(this.props.selectedAmount).toFixed(2)}</td>
														</tr>
														<tr>
															<td>Transaction ID:</td>
															<td>{this.props.currentBatch.id}</td>
														</tr>
														<tr>
															<td>Date:</td>
															<td>{moment().format('DD-MM-YYYY HH:mm:ss')}</td>
														</tr>
													</thead>
												</table>
											</div>
										</div>

										<div class="txn-btn">
											<button type="button" class="print" onClick={this.printDiv}>Print</button>

										</div>
									</div>
								</div>

								<div class="col-12 col-lg-4">
									<div class="card">
										<div class="dashhead">
											<h3>Bank-to-Bank Transfer Details</h3>
										</div>

										<div class="btbtnsfr">
											<p>Now you can load money in your corporate virtual account through NEFT/RTGS as per process shown below.</p>

											<p>Account Details for adding Payee as mentioned as below:</p>

											<div class="table-responsive">
												<table class="table table-bordered">
													<thead>
														<tr>
															<td>Payee Name:</td>
															<td>FinXpay Solutions Pvt. Ltd.</td>
														</tr>
														<tr>
															<td>Account Number:</td>
															<td>FINXPAY4248795778</td>
														</tr>
														<tr>
															<td>Bank Name:</td>
															<td>Yes Bank Ltd.</td>
														</tr>
														<tr>
															<td>Bank IFSC Code:</td>
															<td>YESB0CMSNOC</td>
														</tr>
														<tr>
															<td>Account Type:</td>
															<td>Current Account</td>
														</tr>
													</thead>
												</table>
											</div>
										</div>
									</div>
								</div>

							</div>
						</div>
					</div>
				</div>
				<div class="footer-txt">Copyright &copy; 2021 All rights reserved.
					<br />Powered by FinXpay Solutions Pvt. Ltd.</div>
			</div>
		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage, loginErrorMessage },
		miscReduce: { phone, selectedAmount, currentBatch } }
) => ({
	errorMessage, loginErrorMessage, phone, selectedAmount, currentBatch
});
export default connect(mapStateToProps, null)(PaymentDetails);
